import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { SITE } from "@/lib/site";
import GrainOverlay from "@/components/GrainOverlay";
import SiteFooter from "@/components/SiteFooter";

/* Minimal page chrome for the legal pages. Same dark stone palette,
   same grain overlay, simplified top bar (no anchor links to landing
   sections) and the standard site footer. */
const LegalLayout = ({ title, effectiveDate, testIdRoot, children }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="App relative" data-testid={`${testIdRoot}-page`}>
      <GrainOverlay />

      <header
        className="fixed top-0 left-0 right-0 z-40 bg-[#0B0C10]/85 backdrop-blur-md border-b"
        style={{ borderColor: "var(--soti-rule)" }}
        data-testid={`${testIdRoot}-nav`}
      >
        <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-14 py-5 flex items-center justify-between">
          <Link
            to="/"
            data-testid={`${testIdRoot}-brand`}
            className="flex items-center gap-3 group"
          >
            <span
              className="inline-block w-[10px] h-[10px] rotate-45"
              style={{ background: "var(--soti-cinder)" }}
              aria-hidden="true"
            />
            <span className="overline text-[#F3EFEA] group-hover:text-[#D94833] transition-colors">
              {SITE.brand}
            </span>
          </Link>

          <Link
            to="/"
            data-testid={`${testIdRoot}-back`}
            className="btn-outline"
          >
            <ArrowLeft size={14} strokeWidth={1.4} />
            Back to Home
          </Link>
        </div>
      </header>

      <main className="relative pt-40 md:pt-48 pb-24 md:pb-32">
        <article className="max-w-2xl mx-auto px-6 md:px-10">
          {/* Hairline + overline */}
          <div className="flex items-center gap-4 mb-8">
            <span className="rule rule-cinder" aria-hidden="true" />
            <p className="overline">Legal</p>
          </div>

          <h1
            data-testid={`${testIdRoot}-title`}
            className="font-display text-[#F3EFEA] text-5xl sm:text-6xl md:text-7xl leading-[1.04] tracking-[-0.02em]"
          >
            {title}
          </h1>

          <p
            data-testid={`${testIdRoot}-effective-date`}
            className="overline mt-6"
          >
            Effective Date: {effectiveDate}
          </p>

          <div className="mt-14 legal-prose">{children}</div>
        </article>
      </main>

      <SiteFooter />
    </div>
  );
};

export default LegalLayout;
